<template>
  <v-layout>
    <!---------testimonial----------------------->
    <v-container>
      <v-layout row wrap class="flex_box feature mt-4">
        <v-flex xs12>
          <h5 class="text-xs-center">Testimonial</h5>
          <h2 class="text-xs-center feature_products_title">What <span> People Say</span></h2>
          <div class="title_border"></div>
        </v-flex>
        <v-container fluid class="testimonial brown lighten-5">
          <v-container>
            <v-carousel :cycle="true">
              <v-carousel-item v-for="(review,index) in reviews" :key="index">
                <v-flex xs12 class="testimonial_box">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md5 lg4>
                      <v-img :src="review.image" class="testimonial_client_img"></v-img>
                      <h3>{{review.name}}</h3>
                      <h4><strong>{{review.designation}}</strong></h4>
                    </v-flex>
                    <v-flex xs12 sm6 md7 lg8 class="height_grid">
                      <p><em>{{review.review}}</em></p>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-carousel-item>
            </v-carousel>
          </v-container>
        </v-container>
      </v-layout>
    </v-container>
  </v-layout>
</template>
   
<script>
import firebase from "firebase";
import moment from 'moment'
export default {
  name:'Reviews', 
  data(){
      return{       
        reviews:[]
      }
  },
 
  created(){
    var db = firebase.firestore();   

    // Show All Reviews
    let cref = db.collection('reviews').orderBy('timestamp', 'desc')

    cref.onSnapshot(snapshot => {
      snapshot.docChanges().forEach(change => {
        if(change.type == 'added'){
          let doc = change.doc
          this.reviews.push({
            id:doc.id,                      
            name:doc.data().name,            
            image:doc.data().image,            
            review:doc.data().review,            
            designation:doc.data().designation,
            timestamp:moment(doc.data().timestamp).format('ll'),  
          })
        }
      })
    })

  },  
}
</script>

<style scoped>
.v-carousel__prev {
    left: -15px!important;
}
.v-carousel__next {
    right: -15px!important;
}
.testimonial .v-carousel {
  box-shadow:none;
  height:150px!important;
  padding:0px 80px;
}
.testimonial_box{
  margin-top:24px;
}
@media (max-width:959px){
    .testimonial .v-carousel[data-v-7f0d8933] {
    -webkit-box-shadow: none;
    box-shadow: none;
     padding: 0px 20px!important; 
}
  }
  
.testimonial .container{
  padding:0px!important;
} 
.testimonial .testimonial_client_img{
  width:100px;
  height:100px;
  border:2px solid #345B2C;
  margin-right:20px;
  float:left;
}
.height_grid{
    position: relative;
    padding:0 20px;
    margin-bottom:20px;
  }
  @media (max-width:599px){
    .height_grid{
    margin-top:20px;
  }
  .testimonial .v-carousel {
  box-shadow:none;
  height:200px!important;
}
  }
 .height_grid:before {
    background-image: linear-gradient(to top,#4A8B71,#345B2C);
    top: 0px;
    content: "";
    height: 100px;
    left: 0;
    position: absolute;
    width: 4px;
}
.v-carousel__next .v-btn , .v-carousel__prev .v-btn,.v-item-group .v-btn{
  color:#3E3939!important;
}
.v-carousel__controls {
    background: rgba(0,0,0,.5);
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    bottom: -17px!important;
}
.flex_box h5{
    font-size: 24px!important;
    letter-spacing: 0.4px!important;
    line-height: 15px;
    font-family: 'Yesteryear', cursive;
    text-transform: capitalize;
    color:#3E3939;
  }
  .feature_products_title{
    font-weight: 600;
    font-size: 35px;
    color: #3E3939;
    margin:0px 0px 15px;
    font-family: 'Lobster Two', cursive;
    text-transform: capitalize;
  }
  .testimonial h3{
  font-size:20px!important;
  font-weight: bold;
  font-family: 'Lobster Two', cursive;
}
.testimonial h3,p{
  color:#3E3939;
}


</style>
   


// WEBPACK FOOTER //
// src/components/shop/sections/Reviews.vue